import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { SearchInput, Text, ToastContext } from '@reveni-io/reveni-ui'

import { userPermissions } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'
import routes from '@/Router/routes.constants'

import useIntegrations from './hooks/useIntegrations/useIntegrations'
import IntegrationsContent from './IntegrationsContent/IntegrationsContent'
import * as Styles from './styles'

const IntegrationsConfigurations = () => {
  const { t } = useTranslation()
  const { info } = useContext(AppContext)
  const { setToastInfo } = useContext(ToastContext)
  const navigate = useNavigate()
  const { hasPermission } = useUserPermissions()
  const { integrations, gettingIntegrations, searchQuery, onSearchChange, onToggle, onUninstall } = useIntegrations({
    storeId: info.selectedStore.id,
    setToastInfo,
  })

  const handleClickIntegration = integration => {
    navigate(routes.configurationPage.integrationsDetail.replace(':id', integration.id || 'new'), {
      state: {
        selectedIntegration: integration,
        childPageTitle: integration.name,
      },
    })
  }

  return (
    <Styles.Container>
      <Styles.InfoContainer>
        <Text type="bodyMRegular">
          {t('Conecta todas tus herramientas para obtener el mejor rendimiento para tu empresa.')}
        </Text>
        <SearchInput
          placeholder={t('Buscar integraciones')}
          value={searchQuery}
          onChangeValue={onSearchChange}
          onSearch={onSearchChange}
        />
      </Styles.InfoContainer>

      <IntegrationsContent
        gettingIntegrations={gettingIntegrations}
        integrations={integrations}
        onToggle={onToggle}
        onUninstall={onUninstall}
        handleEditIntegration={handleClickIntegration}
        hasEditPermission={hasPermission(userPermissions.editIntegrations)}
      />
    </Styles.Container>
  )
}

export default IntegrationsConfigurations
